<!--
 * @Description  : 项目结构/类型
 * @Author       : 钱磊
 * @Date         : 2023-04-06 09:33:00
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2024-08-27 11:39:24
 * @FilePath     : \dx_execute_admin\src\views\business-setting\structure-type\index.vue
-->
<!--  -->
<template>
	<div class="h100">
		<w-split class="h100"
				 v-model="splitValue">
			<div class="w-page-main-execute left"
				 slot="left">
				<div class="w-page-header">
					<div class="top-header">
						<div class="title">项目结构配置</div>
						<!-- 鼠标悬浮提示语句 -->
						<div>
							<el-tooltip placement="bottom-start">
								<div slot="content">
									1.对本系统相关业态，相关项目类型，拟定一个项目结构。
									<br />
									2.在后期客户端方便客户使用。
								</div>
								<svg-icon class="help-icon"
										  icon-class="wenhao"></svg-icon>
							</el-tooltip>
						</div>
					</div>
					<div class="next-header">
						<div class="search-input">
							<searchArea ref="searchContent"
										v-model="sname"
										placeholderName="模板名称"
										@on-search="searchTemList"
										:showMore="false"
										:showRefresh="false"></searchArea>
						</div>
						<div>
							<el-button type="primary"
									   size="small"
									   @click="btnClick">新增模板</el-button>
						</div>
					</div>
				</div>

				<div class="w-page-container">
					<left-structure @row-click="fieldClassRowClick"
									@success-callback="fieldClassSuccessCallback"
									ref="leftTable"></left-structure>
				</div>
			</div>

			<div class="w-page-main-execute right"
				 slot="right">
				<div class="w-page-header">
					<div class="top-header flex-between">
						<div class="title mr20">{{ curLeftRow.sname || '' }}</div>
						<div class="right-btn mr0">
							<el-button type="primary"
									   size="small"
									   @click="isEdit = !isEdit"
									   :disabled="isEdit">
								<svg-icon icon-class="unlock"></svg-icon> 解锁
							</el-button>

							<el-button type="warning"
									   size="small"
									   :disabled="!isEdit"
									   @click="saveTree">
								<svg-icon icon-class="save"></svg-icon> 保存
							</el-button>
						</div>
					</div>
					<div class="right-next-header">
						<div class="operation-btns">
							<!-- 展开到几级切换 -->
							<template v-if="levelList.length !== 0">
								<el-select v-model="currnetLevel"
										   size="small"
										   placeholder="请选择"
										   @change="expandByHierarchy($event, 'level')"
										   class="my-select mr10"
										   :disabled="!isEdit">
									<el-option v-for="(item, index) in levelList"
											   :key="'level' + index"
											   :label="item.label"
											   :value="item.value"></el-option>
								</el-select>
							</template>

							<el-button type="primary"
									   plain
									   size="small"
									   :disabled="!isEdit"
									   @click="handleMove('up')"><svg-icon icon-class="shengxu"></svg-icon>
								升序</el-button>
							<el-button type="primary"
									   plain
									   size="small"
									   :disabled="!isEdit"
									   @click="handleMove('down')"><svg-icon icon-class="jiangxu"></svg-icon>
								降序</el-button>
						</div>
						<div class="search-input">
							<searchArea ref="subSname"
										v-model="subSname"
										placeholderName="节点名称"
										@on-search="searchTree"
										:showMore="false"
										:showRefresh="false"></searchArea>
						</div>
					</div>
				</div>
				<div class="w-page-container">
					<right-structure :isEdit="isEdit"
									 @getLevel="getLevel"
									 @change-edit="changeEditState"
									 ref="rightTable"></right-structure>
				</div>
			</div>
		</w-split>
	</div>
</template>
<script>
import { mapState } from 'vuex'
import { returnChinese } from '@/utils/tools'
import LeftStructure from './components/left_structure'
import RightStructure from './components/right_structure'
import searchArea from '@/components/searchArea/searchArea.vue'
export default {
	name: '',
	components: { LeftStructure, RightStructure, searchArea },
	data() {
		return {
			splitValue: 0.4,
			curLeftRow: { sname: '' },
			hierarchy: '2', //展开层级
			sname: '', //项目模板名称
			subSname: '', //节点名称
			isEdit: false, //是否可编辑
			levelList: [],
			currnetLevel: 3,
		}
	},
	created() {},
	mounted() {},
	methods: {
		// 层级转换成中文
		toChinese(data) {
			let str = returnChinese(data)
			return str
		},
		btnClick() {
			this.$refs.leftTable.tableBtnClick('add', '')
		},
		fieldClassRowClick(row) {
			this.curLeftRow = !!row ? row : {}
			this.$refs.rightTable.initSearch(row)
		},
		fieldClassSuccessCallback() {
			this.$refs.rightTable.initSearch(this.curLeftRow)
		},
		// 查询项目结构模板
		searchTemList() {
			this.$refs.leftTable.searchObj.sname = this.sname
			this.$refs.leftTable.getTableList()
		},
		// 升序/降序
		handleMove(type) {
			this.$refs.rightTable.handleMove(type)
		},
		// 保存树结构
		saveTree() {
			this.$refs.rightTable.doSave()
		},

		//保存后功能按钮全部禁用
		changeEditState() {
			this.isEdit = false
		},
		// 右侧搜索树结构
		searchTree() {
			this.$refs.rightTable.searchTree(this.subSname)
		},
		// 获取最高层级的值
		getLevel(value) {
			let arr = []
			for (let i = 1; i <= value; i++) {
				let level = this.toChinese(i)
				let data = {
					label: `展开到${level}级`,
					value: i,
				}
				arr.push(data)
			}
			this.levelList = arr
			this.currnetLevel = value
		},

		// 展开到第几级
		expandByHierarchy(value) {
			let data = value - 1
			this.$refs.rightTable.expandByHierarchy(data)
		},
	},
	computed: {},
}
</script>
<style lang="less" scoped>
.top-header {
	display: flex;
	padding-bottom: 10px;
	div {
		margin-right: 10px;
		line-height: 36px;
	}
	.title {
		min-width: 10px !important;
		font-size: 16px;
		font-family: '微软雅黑 Bold', '微软雅黑 Regular', '微软雅黑';
		font-weight: bold;
		color: #000;
		white-space: nowrap;
		overflow: hidden;
	}
	.mr0 {
		margin-right: 0 !important;
	}
}
.flex-between {
	justify-content: space-between;
}
.next-header {
	display: flex;
	justify-content: flex-end;
	.search-input {
		margin-right: 10px;
	}
}
.right-next-header {
	display: flex;
	margin-top: 5px;
	justify-content: space-between;
	.operation-btns {
		min-width: 260px;
	}
}
.help-icon {
	color: #ff7f7c;
	font-size: 16px;
}
</style>
